import { Box, IconButton, Typography } from "@mui/material";
import { TooltipRenderProps } from "react-joyride";

import { ReactNode } from "react";
import CloseIcon from "../../../assets/images/icons/CloseIcon";
import BriaButton from "../BriaButton/BriaButton";
import { CircleStepIndicator } from "./CircleStepIndicator/CircleStepIndicator";
import styles from "./OnboardingFlowModal.module.scss";

const OnboardingFlowModal: React.FC<TooltipRenderProps> = ({
	closeProps,
	primaryProps,
	tooltipProps,
	step,
	index,
	size,
}) => {
	const generateStepsIndicator = () => {
		const stepsElements = [];
		for (let i = 0; i < size; i++) {
			stepsElements.push(<CircleStepIndicator key={i} isActive={i === index} />);
		}

		return stepsElements;
	};

	const getButtonName = (): ReactNode => {
		if (index == size - 1) return step.locale.last || "Finish";
		return step.locale.next;
	};

	return (
		<Box {...tooltipProps} className={styles.modalContainer}>
			<IconButton
				{...closeProps}
				className={styles.closeButton}
				aria-label={closeProps["aria-label"]}
				title={closeProps.title}
				size="small"
			>
				<CloseIcon className={styles.closeIcon} />
			</IconButton>

			{size > 1 && <Box className={styles.dotsRow}>{generateStepsIndicator()}</Box>}

			<Box className={styles.content}>
				<Typography variant="h6">{step.title}</Typography>
				<Typography variant="body2">{step.content}</Typography>
			</Box>
			<Box className={styles.buttonContainer}>
				<BriaButton
					buttonType="primaryMedium"
					className={styles.gotItButton}
					onClick={primaryProps.onClick}
					aria-label={primaryProps["aria-label"]}
					title={primaryProps.title}
					data-action={primaryProps["data-action"]}
					role={primaryProps.role}
				>
					{getButtonName()}
				</BriaButton>
			</Box>
		</Box>
	);
};

export default OnboardingFlowModal;
